import { z } from "zod";

import { trimString } from "app/utils/trimString";
import { validateArn } from "app/utils/validateArn";

const roleArnPreProcess = z.preprocess(
  trimString,
  z
    .string()
    .optional()
    // validation for ARN format
    .refine((val) => (val ? validateArn(val) : true), {
      message:
        "Invalid ARN format, should be in the format: arn:aws:iam:{account_id}:role/{role_name}",
    }),
);

const optionalRoleArnPreProcess = z.optional(roleArnPreProcess);

export const schema = z
  .object({
    primaryRoleARN: optionalRoleArnPreProcess,
    readOnlyRoleARN: optionalRoleArnPreProcess,
    accountDiscoveryRoleARN: optionalRoleArnPreProcess,
    remediationPolicyRoleARN: optionalRoleArnPreProcess,
  })
  .refine(
    (data) => {
      // Validation logic: primaryRoleARN or all other roles must be provided
      return (
        data.primaryRoleARN ||
        (data.readOnlyRoleARN &&
          data.accountDiscoveryRoleARN &&
          data.remediationPolicyRoleARN)
      );
    },
    {
      message:
        "Either the primary role ARN or all three secondary roles must be provided",
      path: ["root"],
    },
  );

export type FormData = {
  root?: string;
} & z.infer<typeof schema>;
